import ViewContainer from './view-container';
export default ViewContainer;
